import type {Moment} from 'moment-timezone'
import moment from 'moment-timezone'
import type {LangT} from '@freckle/educator-entities/ts/common/helpers/languages'
import type {RenaissanceKeepaliveT} from '@freckle/educator-entities/ts/common/helpers/renaissance-keepalive'
import {extractData, fancyClient} from '@freckle/educator-entities/ts/openapi-clients'

type DehydratedStandardSet = {
  id: string
}

export type SchoolAdminAttrs = {
  id: number
  email: string
  password: string | undefined | null
  mathStandardSet: DehydratedStandardSet
  elaStandardSet: DehydratedStandardSet | undefined | null
  firstName: string
  lastName: string
  renaissanceRPIdentifier: string | undefined | null
  renaissanceKeepalive: RenaissanceKeepaliveT | undefined | null
  sharedRosteringEnabled: boolean
  createdAt: Moment
  language: LangT
  gurId: string | null
}

export function isManagedByRenaissance(schoolAdmin: SchoolAdminAttrs): boolean {
  return (
    schoolAdmin.renaissanceRPIdentifier !== null &&
    schoolAdmin.renaissanceRPIdentifier !== undefined &&
    schoolAdmin.sharedRosteringEnabled
  )
}

export function fetchSchoolAdmin(): Promise<SchoolAdminAttrs> {
  return fancyClient
    .GET('/2/school-admins/me')
    .then(extractData)
    .then(a => ({
      id: a.id,
      email: a.email,
      mathStandardSet: a.mathStandardSet,
      elaStandardSet: a.elaStandardSet,
      firstName: a.firstName,
      lastName: a.lastName,
      renaissanceRPIdentifier: a.renaissanceRPIdentifier,
      renaissanceKeepalive: a.renaissanceKeepalive,
      sharedRosteringEnabled: a.sharedRosteringEnabled,
      password: undefined,
      createdAt: moment(a.createdAt),
      language: a.language as LangT,
      gurId: a.gurId ?? null
    }))
}

type PatchParams = {
  mathStandardSetId?: string | null
  language?: string
}

export function patchSchoolAdmin(data: PatchParams): Promise<SchoolAdminAttrs> {
  return fancyClient
    .PATCH('/2/school-admins/me', {body: data})
    .then(extractData)
    .then(a => ({
      id: a.id,
      email: a.email,
      mathStandardSet: a.mathStandardSet,
      elaStandardSet: a.elaStandardSet,
      firstName: a.firstName,
      lastName: a.lastName,
      renaissanceRPIdentifier: a.renaissanceRPIdentifier,
      renaissanceKeepalive: a.renaissanceKeepalive,
      sharedRosteringEnabled: a.sharedRosteringEnabled,
      password: undefined,
      createdAt: moment(a.createdAt),
      language: a.language as LangT,
      gurId: a.gurId ?? null
    }))
}
